import i18n from 'i18next';
import { hasEnabledFeature } from 'globalutils/fmUtils';
import { checkServiceProvider } from './serviceProviderConfig';

export const getConfig = ({ insuracePortalUserRole, hasCamera }) => ({
  tableColumns: [
    ...(insuracePortalUserRole
      ? [
          {
            id: 'companyName',
            numeric: false,
            disablePadding: true,
            label: i18n.t('policyHolder'),
            needSorting: true,
          },
        ]
      : []),
    {
      id: 'unit_id',
      numeric: false,
      disablePadding: true,
      label: i18n.t('vehicles.unitId'),
      needSorting: true,
    },
    {
      id: 'driversList',
      numeric: true,
      disablePadding: false,
      label: i18n.t('vehicles.drivers'),
      needSorting: true,
    },
    {
      id: 'type',
      numeric: false,
      disablePadding: false,
      label: i18n.t('vehicles.type'),
      needSorting: true,
    },
    {
      id: 'vin',
      numeric: false,
      disablePadding: false,
      label: i18n.t('vehicles.vin'),
      needSorting: true,
    },
    {
      id: 'year',
      numeric: true,
      disablePadding: false,
      label: i18n.t('vehicles.year'),
      needSorting: true,
    },
    {
      id: 'manufact',
      numeric: false,
      disablePadding: false,
      label: i18n.t('vehicles.manufacturer'),
      needSorting: true,
    },
    {
      id: 'model',
      numeric: false,
      disablePadding: false,
      label: i18n.t('vehicles.model'),
      needSorting: true,
    },
    ...(checkServiceProvider('vehicleList_config', window?.$environment?.SERVICE_PROVIDER, false) ||
    (hasCamera && hasEnabledFeature('cameraIntegrationEnabled'))
      ? [
          {
            id: 'actions',
            label: i18n.t('Actions'),
          },
        ]
      : []),
  ],
});
